module.exports = __webpack_public_path__ + "images/section-bg-37-small.webp";